import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { object, string } from "yup";
import { isTemplateExisits, getCache } from "../../../../utils/commonFunctions";
import Config from "../../../../config/app.config.json";
import EnvConfig from "../../../../config/env.config.json";
import { getCC } from "../../../../features/account/accountSlice";
import firebase from "../../../../adapters/firebase";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { getImeiCheck } from "../../../../features/activation/activationSlice";
import { countryList } from "../../../../config/USAStateList";
import { NotificationCust } from "../../../widgets";
import FirebaseDBURLs from "../../../../config/FirebaseDBURLs";
import { getInTouchApi } from "../../../../features/homepage/homepageSlice";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { setMultiSIMVerificationState } from "../../../../features/checkout/checkoutSlice";
import { simVerificationState } from "../../../../features/checkout/Types";
import { getSimInHandContent } from "../../../../features/strapi/checkoutSlice";

interface formikintitaltypes {
  imei: string;
  iccId?: string;
}
const ActivationStep1Comp = isTemplateExisits(Config.Activation.ActivationStep1)
  ? require(`./${Config.Activation.ActivationStep1.template}_ActivationStep1`)
    .default
  : null;
export const ActivationStep1 = (props: any) => {
  const { currentLine, content, gaHandler, handleStep, updatingCustomer } =
    props;
  const dispatch = useAppDispatch();
  const onTimeActivation = localStorage.getItem("oneTimeactivation");

  const [kitBasePrice, setKitBasePrice] = useState<any>(null);
  const [sendSimOption, setSimOption] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [isEsimAvailable, SetIsEsimAvailable] = useState(false);
  const [imei, setImei] = useState<any>(null);
  const { simInHandContent } = useAppSelector((state: any) => state.strapi.checkout);
  const [simInHandCacheContent, setSimInHandCacheContent] = useState();
  const [imeiDataSet, setImeiDataSet] = useState({});
  const [iccidComp, setIccidComp] = useState(true);
  const [esimAvl, setEsimAvl] = useState(true);
  const [deviceSimInHand, setDeviceSimInHand] = useState(currentLine?.simId?.length === 20 && currentLine?.isSimInHand && !currentLine?.esim ? true : false);
  const [deviceComp, setDeviceComp] = useState(
    currentLine?.imei ? true : false
  );
  const [currentModal, setCurrentModal] = useState(
    onTimeActivation ? "oneTimeChrg" : ""
  );
  const { imeiData, imeiNumber } = useAppSelector(
    (state: any) => state?.activation || {}
  );

  const simInHandContentState = simInHandCacheContent
    ? simInHandCacheContent
    : simInHandContent;
  const { msgs } = content || {};
  const { isValid, model, make } = imeiData || {};


  useEffect(() => {
    const customerStoreData: any = JSON.parse(
      localStorage?.getItem("customerDetail") || "null"
    );
    if (customerStoreData)
      dispatch(getCC({ customerId: customerStoreData?.id }));
    fetchData();
    let list = [];
    let simVerficationInitialState: simVerificationState = {
      isSuccess: false,
      error: false,
      pending: false,
    }
    list.push(simVerficationInitialState);
    dispatch(setMultiSIMVerificationState(list));
    EnvConfig?.IS_MULTI_SIM_IN_HAND_ENABLED &&
      getCache(
        "simInHandContentCheckout",
        getSimInHandContent,
        setSimInHandCacheContent,
        dispatch
      );
  }, []);
  useEffect(() => {
    if (isValid && make && model && currentLine.esim !== true) {
      setDeviceComp(true);
    }
  }, [imeiData, isValid]);
  const fetchData = async () => {
    let firstObj: any;
    const shippingRate: any = await firebase
      .database()
      .ref(FirebaseDBURLs.shippingRates);
    shippingRate.on("value", (snapshot: any) => {
      const data = snapshot.val();
      let sendSimOptions: any = [];
      data?.map((el: any) => {
        return sendSimOptions.push({
          label: `${el?.name} - $${el?.shippingAmount.toFixed(2)}`,
          value: el?.serviceType,
          cost: el?.shippingAmount,
          ...el,
        });
      });
      firstObj = sendSimOptions?.[0];
      setSimOption(sendSimOptions);
    });

    const perCost: any = await firebase.database().ref(FirebaseDBURLs.simCost);
    let kitBasePrice = 0;

    perCost.on("value", (snapshot: any) => {
      const data = snapshot.val();
      kitBasePrice =
        data?.USA && ((100 - data.USA.discountPctg) * data.USA.cost) / 100;
      setKitBasePrice(kitBasePrice);
    });
  };
  const hubspotPy = {
    emailId: currentLine?.emailId,
    hubspotMap: {
      device_imei: imeiNumber,
      device_make: make,
      device_model: model,
      website_imei_incompatibility_reason: "",
      is_test: EnvConfig?.IS_HUBSPOT_TEST_ENV,
      is_qa: EnvConfig?.IS_HUBSPOT_QA_ENV,
    },
  };
  const activationStep1Schema = object({
    imei: string().min(15, msgs?.valid_msg),
    iccId: string().trim().min(20, 'iccId must be at least 20 characters'),
  });
  const initialformstep1data: formikintitaltypes = {
    imei: currentLine?.imei || "",
    iccId: currentLine?.simId || "",
  };
  const formik = useFormik({
    initialValues: initialformstep1data,
    validationSchema: activationStep1Schema,
    onSubmit: (values: any) => {
      setBtnLoader(true);
      const py: any = {
        countryCode: countryList?.[0]?.value?.toLowerCase(),
        imei: values?.imei,
      };
      const secondaryUser: any = JSON.parse(
        localStorage?.getItem("secondaryCustomerDetail") || "null"
      );
      let imeiSuccessMsg = content?.step_txt_next
        ? secondaryUser
          ? msgs.imei_noti_sec
          : msgs.imei_noti
        : msgs.imei_noti;

      gaHandler("check");
      dispatch(getImeiCheck({ payload: py })).then((res: any) => {
        setBtnLoader(false);
        const data = res?.payload?.data?.data;
        const { isValid, make, model, esimAvailable } = data || {};
        if (isValid && make && model) {
          if (currentLine?.esim && !esimAvailable) {    
            setCurrentModal("chooseType");
            setEsimAvl(false);
            setImeiDataSet({
              imei: res?.meta?.arg?.payload?.imei.toString(),
              make: data?.make,
              model: data?.model,
              os: data?.os,
              osVer: data?.osVer,
              esimAvailable: data?.esimAvailable,
            })
          } else {
            NotificationCust({
              message: BrandNameUpdate(imeiSuccessMsg),
              duration: 10000,
              id: "activationIMEISuccess",
              showIcon: true,
            });
            
            !EnvConfig.IS_PSIM_TO_ESIM_SWAP_ALLOWED && handleStep(true);
            dispatch(
              getInTouchApi({
                data: hubspotPy,
              })
            );
            setEsimAvl(true);
            updatingCustomer({
              imei: res?.meta?.arg?.payload?.imei.toString(),
              make: data?.make,
              model: data?.model,
              os: data?.os,
              osVer: data?.osVer,
            });
            setCurrentModal("chooseType");
          }
        } else {
          dispatch(
            getInTouchApi({
              data: {
                ...hubspotPy,
                hubspotMap: {
                  ...hubspotPy.hubspotMap,
                  website_imei_incompatibility_reason: "invalid",
                },
              },
            })
          );
          setModalStatus(true);
        }
        setBtnLoader(false);
      }
      );
    },
    enableReinitialize: true,
  });

  return (
    <ActivationStep1Comp
      sendSimOption={sendSimOption}
      kitBasePrice={kitBasePrice}
      deviceComp={deviceComp}
      setDeviceComp={setDeviceComp}
      currentModal={currentModal}
      setCurrentModal={setCurrentModal}
      formik={formik}
      btnLoader={btnLoader}
      setBtnLoader={setBtnLoader}
      modalStatus={modalStatus}
      setModalStatus={setModalStatus}
      isEsimAvailable={isEsimAvailable}
      imei={imei}
      deviceSimInHand={deviceSimInHand}
      setDeviceSimInHand={setDeviceSimInHand}
      iccidComp={iccidComp}
      setIccidComp={setIccidComp}
      simInHandContentState={simInHandContentState}
      esimAvl={esimAvl}
      imeiDataSet={imeiDataSet}
      updatingCustomer={updatingCustomer}
      {...props}
    />
  );
};
